// extracted by mini-css-extract-plugin
export default {"appBarLogo":"MainAppBar_appBarLogo__+ka+F"};